<!-- bankahareketleri.vue -->
<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> Online Banka Hareketleri </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                flat=""
                solo-inverted=""
                hide-details
                v-model="searchsatilanbilet"
                :label="this.$t('Search')"
                append-icon="search"
              >
              </v-text-field>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="ParametreOku()">
                    <v-list-tile-title>{{
                      $t("Definitions")
                    }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Starting-Date')"
                          :detaygizle="false"
                          :rules="[(v) => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla"
                          v-model="KayitTarihiBasla"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp
                          :etiket="$t('Finishing-Date')"
                          :detaygizle="false"
                          :rules="[(v) => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis"
                          v-model="KayitTarihiBitis"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <v-text-field
                          label="Description"
                          v-model="SearcDescription"
                        ></v-text-field>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn
                              color="info"
                              @click="getListBankaHareketleri(false)"
                              fab
                              small
                              dark
                            >
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular
                                indeterminate
                                :width="4"
                                color="blue"
                              ></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green"
                                >check_circle_outline</v-icon
                              >
                            </template>

                            <v-btn
                              small
                              @mouseenter="tooltip = true"
                              @mouseleave="tooltip = false"
                              ref="fab"
                              @click="filtrele()"
                              color="info"
                              fab
                              dark
                            >
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{ $t("Add-Search-Filter") }}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table
                                :headers="headerssatis"
                                :items="itemssatis"
                                :search="searchsatilanbilet"
                                hide-actions
                              >
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">
                                      {{ props.item.row }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.tenantMobileBankName }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.description }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.debtOrCredit }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.amount }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.currency }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.transactionDate }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.transactionTypeName }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.firmName }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{ props.item.iban }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{
                                        props.item.arkmanCariKod +
                                        " - " +
                                        props.item.arkmanCariUnvan
                                      }}
                                    </td>

                                   
                                   
                                    <td class="text-xs-left">
                                      {{ props.item.tenantIban }}
                                    </td>
                                    <td class="text-xs-left">
                                      {{
                                        props.item.tenantArkmanCariKod +
                                        " - " +
                                        props.item.tenantArkmanCariUnvan
                                      }}
                                    </td>

                                  
                                   
                                    <td class="text-xs-left">
                                      {{ props.item.isAktarildi }}
                                    </td>
                                  </tr>
                                </template>
                                <v-alert
                                  slot="no-results"
                                  :value="false"
                                  color="error"
                                  icon="warning"
                                >
                                  {{
                                    $t("No-records-searched-for", {
                                      value: searchsatilanbilet,
                                    })
                                  }}
                                </v-alert>
                              </v-data-table>
                              <v-btn
                                color="primary"
                                :disabled="BaskaKayitYok"
                                @click="getListBankaHareketleri(true)"
                                >Sonraki {{ Top }} kayit</v-btn
                              >
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{
              $t("Close")
            }}</v-btn>
          </v-snackbar>

          <v-dialog
            v-model="dialogfiltre"
            scrollable
            persistent
            max-width="500px"
          >
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t("Filter-selection") }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-text-field
                                label="Tutar1"
                                v-model="odemeRapor.Value.Tutar1"
                              ></v-text-field>
                              <v-text-field
                                label="Tutar1"
                                v-model="odemeRapor.Value.Tutar2"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select
                                :label="$t('Payment-Type')"
                                items-value="value"
                                item-text="text"
                                :items="odemeItems"
                                v-model="odemeRapor.Value.BA"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtreiptal()"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="filtrekayit()"
                  >{{ $t("Apply-Filters") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogayarlar"
            scrollable=""
            persistent=""
            max-width="500px"
          >
            <v-card color="grey lighten-5">
              <v-card-title>Finekra Banka Entegrasyon {{ $t("Definitions") }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      label="email"
                      v-model="Ayarlar.email"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      label="pasword"
                      v-model="Ayarlar.password"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      label="tenantCode"
                      v-model="Ayarlar.tenantCode"
                    >
                    </v-text-field>
                  </v-flex>
                  
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="dialogayarlar = false"
                  >Kapat</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="ayarkaydet()"
                  >{{ $t("save_button") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
import auth from "@/api/auth";
import tarihcomp from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "@/components/app/coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import rez from "@/components/app/coper/rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";

export default {
  data() {
    return {
      PB: "TRY",
      tumsirketler: false,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      filtrevarmi: false,
      search: "",
      searchsatilanbilet: null,
      searchiadebilet: null,
      searchvoid: null,

      dialogayarlar: false,
      Ayarlar: {
            
      },

      headerssatis: [
        {
          text: "Row",
          value: "row",
          width: "5%",
          align: "left",
        },
        {
          text: "BankName",
          value: "tenantMobileBankName",
          width: "10%",
          align: "left",
        },
        {
          text: "Description",
          value: "description",
          width: "30%",
          align: "left",
        },
        {
          text: "B/A",
          value: "debtOrCredit",
          width: "3%",
          align: "left",
        },
        {
          text: "Amount",
          value: "amount",
          width: "4%",
          align: "left",
        },
        {
          text: "Currency",
          value: "currency",
          width: "4%",
          align: "left",
        },
        {
          text: "Date",
          value: "transactionDate",
          width: "10%",
          align: "left",
        },

        {
          text: "Type",
          value: "transactionTypeName",
          width: "4%",
          align: "left",
        },

        {
          text: "FirmName",
          value: "firmName",
          width: "15%",
          align: "left",
        },
        {
          text: "IBAN",
          value: "iban",
          width: "12%",
          align: "left",
        },
        {
          text: "arkmanCariKod",
          value: "arkmanCariKod",
          width: "15%",
          align: "left",
        },

        {
          text: "Tenant IBAN",
          value: "tenantIban",
          width: "12%",
          align: "left",
        },
        {
          text: "tenantArkmanCariKod",
          value: "tenantArkmanCariKod",
          width: "15%",
          align: "left",
        },
        

        {
          text: "Aktarildi",
          value: "isAktarildi",
          width: "5%",
          align: "left",
        },
      ],
      odemeItems: [
        {
          text: "",
          value: "",
        },
        {
          text: "Borç",
          value: "B",
        },
        {
          text: "Alacak",
          value: "A",
        },
      ],
      odemeRapor: {
        Value: {
          PNR_No: null,
          SaticiTip: null,
          SaticiKod: null,
          HesapKodu: null,
          Tarih1: null,
          Tarih2: null,
          BA: "",

          Tutar1: "",
          Tutar2: "",
        },
        Limit: null,
      },

      SayfaNo: 1,
      Top: 30,
      BaskaKayitYok: true,
      SearcDescription: "",

      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      itemsairlinelist: [],
      hesapgurubu: [],
      masrafmerkezi: [],
      doviztipi: [],
      valid: true,
      totalCount: 0,
      totalService: 0,
      totalAmount: 0,
      StartDate: null,
      EndDate: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",

      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      kredikarti: [],
      statecari: [],
      searchcari: "",
      progress: false,
      tooltip: false,
      el: null,
      yok: false,
      itemssatis: [],

      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date"),
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date"),
          },
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,

  mounted() {
    this.el = this.$refs.fab.$el;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    this.PB = credentials.ParaBirimi;
    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            this.$validator.localize("en", this.dictionary);
            this.el = this.$refs.fab.$el;
            var credentials = JSON.parse(
              window.localStorage.getItem("credentials")
            );

            var params = {
              CompanyCode: credentials.SirketKodu,
            };

            this.$http
              .post(auth.API_URL + "api/currency/List", params, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              })
              .then(
                (response) => {
                  this.doviztipi = response.body;
                },
                (response) => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  }
                }
              );

            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },

  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    cariaracomp,
  },
  watch: {},
  methods: {
    HataYonetimi(response, request, baslik) {
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    git(v) {
      if (v.isAktarildi == true) {
        let url =
          "#/carihareketler/duzenle/id?" +
          "ac=" +
          v.carihareket_HesapKodu +
          "&dt=" +
          v.carihareket_Tarih +
          "&on=" +
          v.carihareket_SiraNo;
        window.open(url, "_blank");
      } else {
        let url = "#carihareketler/yeni/?islem=get&id=" + v.id;
        window.open(url, "_blank");
      }
    },
    getListBankaHareketleri: getListBankaHareketleri,

    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
    ParametreOku:ParametreOku,
    ayarkaydet:ayarkaydet,
  },
};

function filtrele() {
  this.dialogfiltre = true;
}

function filtrekayit() {
  this.filtrevarmi = true;
  this.dialogfiltre = false;
  this.getListBankaHareketleri(false);
}

function filtreiptal() {
  this.filtrevarmi = false;
  this.dialogfiltre = false;

  this.odemeRapor.Value.PNR_No = null;
  this.odemeRapor.Value.SaticiTip = null;
  this.odemeRapor.Value.HesapKodu = null;
  this.odemeRapor.Value.BA = "";
  this.odemeRapor.Value.SaticiKod = null;

  this.odemeRapor.Value.Tutar1 = "";
  this.odemeRapor.Value.Tutar2 = "";

  this.tumsirketler = false;

  this.getListBankaHareketleri(false);
}

function getListBankaHareketleri(SonrakiKayit) {
  if (this.$refs.formgunluksatis.validate()) {
    var bastarih = new Date(this.KayitTarihiBasla);
    var bittarih = new Date(this.KayitTarihiBitis);

    if (bastarih <= bittarih) {
      this.progress = true;
      this.load1 = false;

      this.BaskaKayitYok = true;

      if (SonrakiKayit == false) {
        this.SayfaNo = 1;
      }
      if (SonrakiKayit == true) {
        this.SayfaNo++;
      }

      var params = {
        Filtreler: {
          Tarih1: this.KayitTarihiBasla,
          Tarih2: this.KayitTarihiBitis,
          SearchText: this.SearcDescription,
          Tutar1: this.odemeRapor.Value.Tutar1,
          Tutar2: this.odemeRapor.Value.Tutar2,
          BA: this.odemeRapor.Value.BA,
        },
        Sayfa: this.SayfaNo,
        Top: this.Top,

        tumSirketler: this.tumsirketler,
        sayfaAdi: this.$route.name,
      };

      tool.api_post(this, "BankaStream/HesapHareketleri", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (response.body.data.length < this.Top) {
              this.BaskaKayitYok = true;
            } else {
              this.BaskaKayitYok = false;
            }

            if (SonrakiKayit != true) {
              this.itemssatis = response.body.data;
            } else {
              this.itemssatis = this.itemssatis.concat(response.body.data);
            }

            this.progress = false;
            this.load1 = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
          }
        },
        (response) => {
          this.HataYonetimi(response, params, "Banka Hareketleri Getirilemedi");
          this.progress = false;
          this.load1 = true;
        }
      );
    } else {
      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
    }
  }
}

function ParametreOku() {
  tool.api_post(this, "BankaStream/FinekraParametreOku", {})
    .then(
      (response) => {

        if (response.body.data!=null)
        {
          this.Ayarlar = response.body.data;
        }
        this.dialogayarlar = true;
      },
      (response) => {
        this.text1 = "Ayarlar getirilemedi tekrar deneyiniz.";
        this.snackbar = false;
      }
    );
}

function ayarkaydet() {
  
  let params = { 
    TokenInfo:this.Ayarlar
  }

  tool.api_post(this, 'BankaStream/FinekraParametreYaz', params).then((response) => {

    if (response.body.Status === true) {
      this.dialogayarlar = false
    } else {
      this.text1 = this.$t('Error-please-try-again')
      this.snackbar = false
    }


  }, (response) => {
    this.text1 = this.$t('Error-please-try-again')
    this.snackbar = false
  })


}


function beforeMount() {}
</script>
<style>
</style>